/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetEmployeeRoleRequest
 */
export interface SetEmployeeRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof SetEmployeeRoleRequest
     */
    role: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetEmployeeRoleRequest
     */
    roles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SetEmployeeRoleRequest
     */
    engagement?: string | null;
}

/**
 * Check if a given object implements the SetEmployeeRoleRequest interface.
 */
export function instanceOfSetEmployeeRoleRequest(value: object): value is SetEmployeeRoleRequest {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function SetEmployeeRoleRequestFromJSON(json: any): SetEmployeeRoleRequest {
    return SetEmployeeRoleRequestFromJSONTyped(json, false);
}

export function SetEmployeeRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEmployeeRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'engagement': json['engagement'] == null ? undefined : json['engagement'],
    };
}

export function SetEmployeeRoleRequestToJSON(json: any): SetEmployeeRoleRequest {
    return SetEmployeeRoleRequestToJSONTyped(json, false);
}

export function SetEmployeeRoleRequestToJSONTyped(value?: SetEmployeeRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'roles': value['roles'],
        'engagement': value['engagement'],
    };
}

